<div class="grid-container">
<div class="content content-with-elevation">
  <div class="grid-x" *ngIf="!emailSent">
    <div class="cell small-12 medium-12 large-12">
      <p>Delegation of a new generic top-level domain (gTLD) is the process of delegating operational
        responsibility for managing the domain’s root zone delegation to a new entity, plus adding the
        necessary records to the DNS root zone to make the top-level domain functional on the
        Internet. This process is conducted after an applicant successfully completed the <a href='https://newgtlds.icann.org/en/'>"New gTLD Application Process"</a> managed by
        ICANN.</p>

      <div class="grid-x">
        <div class="cell large-8 small-12 medium-8">
          <p>Following successful completion of the "New gTLD Application Process", applicants are provided with a delegation
            token. If you have received this token and are ready to commence the delegation process, provide it here.
          </p>
          <form class="content-with-elevation content" [formGroup]="newDelegationForm" (ngSubmit)="onSubmit()" novalidate>
            <div class="grid-y">
              <common-alerts [error]="errorMessages"></common-alerts>
              <div class="grid-x">
                <div class="small-0 large-1 medium-0">
                </div>
                <div class="small-12 large-8 medium-12">
                  <div class="grid-x">
                    <div class="cell large-4 medium-5 small-12">
                      <label class="label-center">New gTLD</label>
                    </div>
                    <div class="large-8 medium-7 small-12">
                      <input formControlName="newGTLD" placeholder=".example"
                             class="input-group-custom" required>
                    </div>
                  </div>
                  <div class="grid-x">
                    <div class="cell large-4 medium-5 small-12">
                      <label class="label-center">Delegation Token</label>
                    </div>
                    <div class="large-8 medium-7 small-12">
                      <input formControlName="delegationToken"
                             placeholder="XXXX-XXXX-XXXX"
                             class="input-group-custom">
                    </div>
                  </div>

                  <div class="grid-x button-placement-right" style="margin-top: 16px">
                    <button class="iana-button" type="submit"
                            [disabled]="!newDelegationForm.valid">Start Process
                    </button>
                  </div>
                </div>
                <div class="small-0 large-3 medium-0">
                </div>
              </div>
            </div>
          </form>

        </div>
        <div class="cell large-4 small-12 medium-4" style="display: flex; justify-content: center">
          <img src="assets/images/tas-intro.png"/>
        </div>
      </div>


    </div>
  </div>

  <div class="grid-x" *ngIf="emailSent">
    <h3><b>Please follow instructions in email</b></h3>
  </div>
</div>
</div>
